// Configuration Stripe
import API_BASE_URL from './api'; 
import { getEnvConfig } from './environment';

// Fonction pour obtenir la clé publique
export const getStripePublishableKey = () => {
  const config = getEnvConfig();
  return config.stripePublishableKey;
};

// Fonction pour obtenir l'URL de l'API
export const getApiUrl = () => {
  const config = getEnvConfig();
  return config.apiUrl;
};

// Fonction pour vérifier la configuration Stripe
export const validateStripeConfig = () => {
  const config = getEnvConfig();
  const errors = [];
  
  if (!config.stripePublishableKey) {
    errors.push('Clé publique Stripe manquante');
  }
  
  if (!config.apiUrl) {
    errors.push('URL de l\'API manquante');
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    config
  };
};














